import React from 'react'

import CourseData from '../courseData'
import bell from '../images/bell.gif'

const CourseComponent = ({ title }) => {

    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="container-fluid p-5 m-0 course_header" >
                    <div className="container text-white ">
                        <div className="row">
                            <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 mx-auto my-auto order-lg-1 order-2 order-2">
                                {
                                    CourseData.map((item, ind) => {
                                        if (title == item.title) {
                                            return (
                                                <>
                                                    <h1 className="font-weight-bold">{item.title}</h1>
                                                    <p>{item.description}</p>
                                                    <p><i>{item.content}</i></p>
                                                    <h5>Course Creator:<i> <b>{item.creator}</b></i></h5>
                                                </>
                                            )
                                        }
                                    })
                                }
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mx-auto order-lg-2 my-auto order-sm-1 order-xs-1">
                                {
                                    CourseData.map((item, ind) => {
                                        if (title == item.title) {
                                            return (
                                                <div className="card-img">
                                                    <img src={item.img} className="img-responsive img-fluid"
                                                        style={{ width: "24rem", height: "auto" }} />
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" >
                    <div className="d-flex justify-content-center align-items-center text-center border rounded-2 bg-white shadow-sm my-5 mx-auto" style={{ margin: "-10px 0 0 0" }}>
                        <img src={bell} style={{ width: "80px", height: "80px" }} /><h4>
                            We Conduct <span className="font-weight-bold text-primary">Live Workshops & Classes </span>for you to get job ready.
                        </h4>
                    </div>
                </div>
                <div className="container my-5 p-3 ">
                    <div className='row'>
                        <div className="col-lg-8 col-md-8 col-sm-12 mx-auto ml-5">
                            <h2><strong>Goals</strong></h2>
                            <ul className="mt-4 list_style text-left font-weight-bold" >
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Go from a total beginner to an advanced JavaScript developer</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>JavaScript and programming fundamentals: variables, boolean logic, if/else, loops, functions, arrays, etc.</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Modern JavaScript for 2020: NPM, Webpack, Babel and ES6 modules</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>A true understanding of how JavaScript works behind the scenes</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Organize and structure your code using JavaScript patterns like modules</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Practice your new skills with coding challenges (solutions included)</li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12  mx-auto">
                            <div className="card shadow">
                                <div className="card-body font-weight-bold">
                                    {
                                        CourseData.map((item, ind) => {
                                            if (title == item.title) {
                                                return (
                                                    <>
                                                        <ul>
                                                            <li className="my-3"><i className="fa fa-desktop" aria-hidden="true"></i> {item.course_content[0]}</li>
                                                            <li className="my-3"><i className="fa fa-code" aria-hidden="true"></i> {item.course_content[1]}</li>
                                                            <li className="my-3"><i className="fa fa-check-circle" aria-hidden="true"></i> {item.course_content[2]}</li>
                                                            <li className="my-3"><i className="fa fa-credit-card-alt" aria-hidden="true"></i> {item.course_content[3]}</li>
                                                            <li className="my-3"><i className="fa fa-shield" aria-hidden="true"></i> {item.course_content[4]}</li>

                                                        </ul>
                                                        <a href="https://play.google.com/store/apps/details?id=com.career_grads"><button className="btn btn-block btn-explore bg-primary text-white
                                                            font-weight-bold my-3 mx-auto">
                                                            Get Our App</button></a>
                                                    </>
                                                );
                                            }

                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default CourseComponent
